import moment from "moment"

// Logique pure de la page /taches (proposition B, Jordan 31.10.2026) :
// semaine affichée, liste des mécaniciens, progression, modifications non
// enregistrées, ponctuelles rangées par jour. Testée dans tachesSemaine.test.js.

export const VIDE = { tv: [], ta: [], td: [] }

const MOIS = [
	"janv.",
	"févr.",
	"mars",
	"avr.",
	"mai",
	"juin",
	"juil.",
	"août",
	"sept.",
	"oct.",
	"nov.",
	"déc.",
]
// Index = delta_day (0 = lundi).
export const JOURS_COURTS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"]
export const JOURS_ABREGES = [
	"lun.",
	"mar.",
	"mer.",
	"jeu.",
	"ven.",
	"sam.",
	"dim.",
]
export const JOURS_NOMS = [
	"lundi",
	"mardi",
	"mercredi",
	"jeudi",
	"vendredi",
	"samedi",
	"dimanche",
]

export const semaineDe = (m) => {
	const startDate = moment(m).startOf("isoWeek")
	return { startDate, endDate: startDate.clone().add(6, "days") }
}

const jourMois = (m) => `${m.date()} ${MOIS[m.month()]}`

// « 26 oct. – 1 nov. »
export const libelleSemaine = (startDate) =>
	`${jourMois(startDate)} – ${jourMois(startDate.clone().add(6, "days"))}`

// « Semaine en cours », « Semaine prochaine », « Il y a 3 semaines »…
export const libelleEcart = (startDate, aujourdhui = moment()) => {
	const n = Math.round(
		startDate.diff(moment(aujourdhui).startOf("isoWeek"), "days") / 7,
	)
	if (n === 0) return "Semaine en cours"
	if (n === -1) return "Semaine dernière"
	if (n === 1) return "Semaine prochaine"
	return n < 0 ? `Il y a ${-n} semaines` : `Dans ${n} semaines`
}

// « Prévue ven. 23 oct. » (date_effective du serveur, format DD-MM-YYYY).
export const libellePrevue = (td) => {
	const m = moment(td.date_effective || td.date, "DD-MM-YYYY")
	if (!m.isValid()) return "Prévue"
	return `Prévue ${JOURS_ABREGES[(m.isoWeekday() + 6) % 7]} ${jourMois(m)}`
}

export const tvFaite = (tv) =>
	(tv.items || []).length > 0 && tv.items.every((i) => i.done)

export const tachesDe = (taches, empId) => taches[empId] || VIDE

// Une entrée par tâche, dans l'ordre véhicules → autres → ponctuelles :
// la barre de progression trace un trait par tâche.
export const progression = (t) => {
	const traits = [
		...t.tv.map(tvFaite),
		...t.ta.map((ta) => !!ta.done),
		...t.td.map((td) => td.etat === 2),
	]
	const faites = traits.filter(Boolean).length
	const enRetard = t.td.filter((td) => td.reportee && td.etat !== 2).length
	return { traits, faites, total: traits.length, enRetard }
}

export const nbAEnvoyer = (t) =>
	[...t.tv, ...t.ta, ...t.td].filter((x) => !x.envoye).length

// Employés ACTIFS seulement (un inactif n'apparaît jamais, même avec des
// tâches — Jordan 31.10), dans l'ordre de la liste. `masquerSansTache` :
// seulement ceux qui ont au moins une tâche dans la semaine affichée
// (reportées comprises).
export const mecaniciens = (actifs, taches, masquerSansTache = false) =>
	(actifs || []).filter(
		(e) =>
			!masquerSansTache || progression(tachesDe(taches, e.id)).total > 0,
	)

// Mécanicien sélectionné par défaut : le premier qui a des tâches.
export const premierAvecTaches = (liste, taches) => {
	const e = liste.find((x) => progression(tachesDe(taches, x.id)).total > 0)
	return e ? e.id : liste.length ? liste[0].id : 0
}

// Ponctuelles d'un mécanicien rangées pour l'affichage. `index` = position
// dans `td` (les mutations se font par index). Les reportées non terminées
// vont dans « En retard » (jour non modifiable : le serveur garde leur date).
export const rangerPonctuelles = (tds) => {
	const enRetard = []
	const parJour = [[], [], [], [], [], [], []]
	const sansJour = []
	tds.forEach((td, index) => {
		const e = { td, index }
		if (td.reportee) {
			if (td.etat !== 2) enRetard.push(e)
		} else if (td.delta_day >= 0 && td.delta_day <= 6) {
			parJour[td.delta_day].push(e)
		} else {
			sansJour.push(e)
		}
	})
	return { enRetard, parJour, sansJour }
}

// Modifications non enregistrées, comptées contre l'état chargé : une tâche
// nouvelle (id 0), modifiée ou déplacée vers un autre mécanicien = 1.
const indexer = (taches) => {
	const res = {}
	let nouvelles = 0
	Object.entries(taches || {}).forEach(([empId, t]) => {
		;["tv", "ta", "td"].forEach((type) => {
			;(t[type] || []).forEach((x) => {
				if (!x.id) nouvelles += 1
				else res[`${type}:${x.id}`] = JSON.stringify([String(empId), x])
			})
		})
	})
	return { res, nouvelles }
}

export const nbModifications = (charge, courant) => {
	const a = indexer(charge).res
	const { res: b, nouvelles } = indexer(courant)
	let n = nouvelles
	Object.entries(b).forEach(([k, v]) => {
		if (a[k] !== v) n += 1
	})
	return n
}
